import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerLeads = lazy(() => import("@/pages/partner/PartnerLeads"));

export const Route = createFileRoute("/partner/leads")({
  head: () => ({
    meta: [
      { title: "Mina leads – Partnerportal" },
      { name: "description", content: "Alla leads som levererats till er från Elmarknad.se." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerLeads />,
});
